/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
  // BrowserRouter as Router,
  // Switch,
  // useLocation,
  Link,
  // useHistory,
} from "react-router-dom";

const securePath = '';

export function SideBar(props) {
  return (
    <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
      {/* Sidebar - Brand */}
      <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/">
        <div className="sidebar-brand-icon rotate-n-15">
          <i className="fas fa-cube"></i>
        </div>
        <div className="sidebar-brand-text mx-3">Work Cube</div>
      </Link>

      {/* Divider */}
      <hr className="sidebar-divider my-0" />

      {/* Nav Item - Dashboard */}
      <li className="nav-item">
        <Link className="nav-link" to={`${securePath}/dashboard`}>
          <i className="fas fa-fw fa-tachometer-alt"></i>
          <span>Dashboard</span>
        </Link>
      </li>

      {/* Divider */}
      <hr className="sidebar-divider" />

      {/* Heading */}
      <div className="sidebar-heading">
        <span className="text-lg">Activities</span>
      </div>

      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
        <Link className="nav-link" to={`${securePath}/work-order`}>
          <i className="fas fa-bullhorn"></i>
          <span>คำสั่งผลิต</span>
        </Link>

        {/* 
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseActivity"
          aria-expanded="true"
          aria-controls="collapseActivity"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>งาน / กิจกรรม</span>
        </a>
        <div id="collapseActivity" className="collapse" aria-labelledby="headingActivity" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <Link className="collapse-item" to={`${securePath}/activity`}>
              สิ่งที่ต้องทำ / เตือน
            </a>
            <Link className="collapse-item" to={`${securePath}/contact`}>
              รายชื่อผู้ติดต่อ
            </a>
          </div>
        </div>
        */}
      </li>

      {/* Divider */}
      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">Planning</span>
      </div>

      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
      <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapsePlanEntry"
          aria-expanded="true"
          aria-controls="collapsePlanEntry"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>วางแผน</span>
        </a>
        <div
          id="collapsePlanEntry"
          className="collapse"
          aria-labelledby="headingPlanEntry"
          data-parent="#accordionSidebar"
        >
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">วางแผน:</h6>
            <Link className="collapse-item" to={`${securePath}/work-report/no-due`}>
              ยังไม่กำหนดวันส่ง
            </Link>
            <Link className="collapse-item" to={`${securePath}/work-report/wait-approve`}>
              รออนุมัติ
            </Link>
            <h6 className="collapse-header">ปฏิทิน:</h6>
            <Link className="collapse-item" to={`${securePath}/calendar/due`}>
              กำหนดส่งงาน
            </Link>
          </div>
        </div>
      </li>

      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">Reports</span>
      </div>

      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseSalesEntry"
          aria-expanded="true"
          aria-controls="collapseSalesEntry"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>ฝ่ายผลิต</span>
        </a>
        <div
          id="collapseSalesEntry"
          className="collapse"
          aria-labelledby="headingSalesEntry"
          data-parent="#accordionSidebar"
        >
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">ปัจจุบัน:</h6>
            <Link className="collapse-item" to={`${securePath}/work-report/pending`}>
              รอผลิต/ยังไม่เริ่ม
            </Link>
            <Link className="collapse-item" to={`${securePath}/work-report/over-due`}>
              เกินเวลากำหนด
            </Link>
            <Link className="collapse-item" to={`${securePath}/work-report/in-progress`}>
              ระหว่างผลิต
            </Link>
            <Link className="collapse-item" to={`${securePath}/work-report/near-due`}>
              ใกล้ถึงกำหนด
            </Link>

            <h6 className="collapse-header">ประวัติ:</h6>
            <Link className="collapse-item" to={`${securePath}/work-history/product`}>
              สรุปยอดสินค้า
            </Link>
            <Link className="collapse-item" to={`${securePath}/work-history/contact`}>
              สรุปยอดลูกค้า
            </Link>
            {/*
            <Link className="collapse-item" to={`${securePath}/work-search`}>
              สืบค้นประวัติ
            </Link>
            */}
          </div>
        </div>
      </li>

      {/* Nav Item - Pages Collapse Menu */}
      {/*
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseTwo"
          aria-expanded="true"
          aria-controls="collapseTwo"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>จัดซื้อ</span>
        </a>
        <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">จัดทำเอกสาร:</h6>
            <Link className="collapse-item" to={`${securePath}/purchase-order">
              ใบสั่งซื้อ
            </a>
          </div>
        </div>
      </li>
      */}
      {/* Nav Item - Pages Collapse Menu */}
      {/*
<li className="nav-item">
    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
        <i className="fas fa-fw fa-cog"></i>
        <span>คลังสินค้า</span>
    </a>
    <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
        <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Custom Components:</h6>
            <Link className="collapse-item" to="buttons.html">Buttons</a>
            <Link className="collapse-item" to="cards.html">Cards</a>
        </div>
    </div>
</li>
*/}

      {/* Divider */}
      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">Settings</span>
      </div>
      {/*
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseMaster"
          aria-expanded="true"
          aria-controls="collapseMaster"
        >
          <i className="fas fa-fw fa-clone"></i>
          <span>Masters</span>
        </a>
        <div id="collapseMaster" className="collapse" aria-labelledby="headingMaster" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Master Data:</h6>
            <Link className="collapse-item" to={`${securePath}/spare-part">
              Spare Part
            </a>
            <Link className="collapse-item" to={`${securePath}/department">Departments</a>
            <Link className="collapse-item" to={`${securePath}/valid-option">
              Valid Options
            </a>
          </div>
        </div>
      </li>
      */}
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseSystem"
          aria-expanded="true"
          aria-controls="collapseTwo"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>System</span>
        </a>
        <div id="collapseSystem" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">System Configs:</h6>
            <Link className="collapse-item" to={`${securePath}/org-user`}>Users</Link>
            {/*
            <Link className="collapse-item" to={`${securePath}/employee`}>
              Employees
            </Link>
            <Link className="collapse-item" to={`${securePath}/system-config`}>
              System Values
            </Link>
            <Link className="collapse-item" to={`${securePath}/valid-option`}>
              Valid Options
            </Link>
            <Link className="collapse-item" to={`${securePath}/user-role`}>
              User Role
            </Link>
            */}
            <Link className="collapse-item" to={`${securePath}/org-info`}>
              Organization
            </Link>
          </div>
        </div>
      </li>

      {/* Divider */}
      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">HELP</span>
      </div>
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseHelp"
          aria-expanded="true"
          aria-controls="collapseHelp"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>Usage</span>
        </a>
        <div id="collapseHelp" className="collapse" aria-labelledby="headingHelp" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Manual:</h6>
            <a className="collapse-item" href={`/help-usage.html`} target="_blank" rel="noreferrer">คู่มือการใช้งาน</a>
          </div>
        </div>        
      </li>

      {/* Divider */}
      <hr className="sidebar-divider d-none d-md-block" />

      {/* Sidebar Toggler (Sidebar) */}
      <div className="text-center d-none d-md-inline">
        <button className="rounded-circle border-0" id="sidebarToggle"></button>
      </div>
    </ul>
  );
}
